module.exports = __webpack_public_path__ + "img/harsh_braking.c132807c.svg";